
import LockAndUnlock from "../../../../components/quality/logs-and-checklists/lock-and-unlock/mapview";
const Index = () => {
    return <LockAndUnlock />
}

export default Index;